var map = {
	"./admin_settings.png": 1725,
	"./catalog.png": 1726,
	"./catalogWhite.png": 1727,
	"./catalog_orders.png": 1728,
	"./cms.png": 1729,
	"./component-fields/Asset.png": 1730,
	"./component-fields/Blocks.png": 1731,
	"./component-fields/Boolean.png": 1732,
	"./component-fields/Date-time.png": 1733,
	"./component-fields/LInk.png": 1734,
	"./component-fields/Markdown.png": 1735,
	"./component-fields/Multi asset.png": 1736,
	"./component-fields/Multi options.png": 1737,
	"./component-fields/Number.png": 1738,
	"./component-fields/Richtext.png": 1739,
	"./component-fields/Single options.png": 1740,
	"./component-fields/Table.png": 1741,
	"./component-fields/Text area.png": 1742,
	"./component-fields/Text.png": 1743,
	"./components.png": 1744,
	"./configuration.png": 1745,
	"./contents.png": 1746,
	"./crm.png": 1747,
	"./custom_order.png": 1748,
	"./customer_credits.png": 1749,
	"./customer_list.png": 1750,
	"./dashboard.png": 1751,
	"./finance.png": 1752,
	"./home.png": 1753,
	"./integrations.png": 1754,
	"./inventory-transfers.png": 1755,
	"./invoice-list.png": 1756,
	"./layaway.png": 1757,
	"./move.png": 1758,
	"./new_sale.png": 1759,
	"./orders.png": 1760,
	"./outgoing-consignments.png": 1761,
	"./payment-methods/amex.png": 1127,
	"./payment-methods/discover.png": 1126,
	"./payment-methods/mastercard.png": 1125,
	"./payment-methods/visa.png": 1124,
	"./payments.png": 1762,
	"./plus.png": 1347,
	"./register.png": 1763,
	"./repair_center.png": 1764,
	"./reports.png": 1765,
	"./services.png": 1766,
	"./trade_in_center.png": 1767
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1392;